import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { GuardService } from "./guard.service";
import { ContactInfoComponent } from "./modules/contact-info/contact-info.component";
import { ChooseClothesComponent } from "./modules/customize/choose-clothes/choose-clothes.component";
import { PreorderComponent } from "./modules/customize/preorder/preorder.component";
import { FailureComponent } from "./modules/failure/failure.component";
import { SuccessComponent } from "./modules/success/success.component";

const routes: Routes = [
  { path: "", redirectTo: "/customize", pathMatch: "full" },
  {
    path: "customize",
    component: ChooseClothesComponent,
  },
  {
    path: "jersey",
    canActivate: [GuardService],
    loadChildren: () =>
      import("./modules/customize/customize-jersey/jersey.module").then(
        (m) => m.JerseyModule
      ),
  },
  {
    path: "shorts-socks",
    canActivate: [GuardService],
    loadChildren: () =>
      import(
        "./modules/customize/customize-short-&-socks/shorts-socks.module"
      ).then((m) => m.ShortsSocksModule),
  },
  {
    path: "summary",
    canActivate: [GuardService],
    loadChildren: () =>
      import("./modules/customize/kit-summary/summary.module").then(
        (m) => m.SummaryModule
      ),
  },
  {
    path: "preorder",
    canActivate: [GuardService],
    component: PreorderComponent,
  },
  {
    path: "contact-info/:type",
    canActivate: [GuardService],
    component: ContactInfoComponent,
  },
  {
    path: "success",
    canActivate: [GuardService],
    component: SuccessComponent,
  },
  {
    path: "failure",
    canActivate: [GuardService],
    component: FailureComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
